export function async (client: unknown) {
  // @ts-expect-error // It's okay
  return ({ dispatch, getState }) => next => action => {
    // If the action isn't an array, we don't need to load anything async
    if (typeof action === 'function') {
      return action(dispatch, getState)
    }

    let { promise, types, ...rest } = action

    // We can also skip if we don't have a promise we need to resolve
    if (!promise) {
      return next(action)
    }

    let [ REQUEST, SUCCESS, FAILURE ] = types
    next({
      ...rest,
      type: REQUEST
    })

    let actionPromise = promise(client)

    actionPromise
      .then(
        (result: unknown) => next({
          ...rest,
          result,
          type: SUCCESS
        }),
        (error: unknown) => next({
          ...rest,
          error,
          type: FAILURE
        })
      )
      .catch((error: unknown) => {
        console.error('MIDDLEWARE ERROR:', error)

        next({
          ...rest,
          error,
          type: FAILURE
        })
      })

    return actionPromise
  }
}
